import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Home', path: '/' },
  { label: 'Services', path: '/services' },
  { label: 'About', path: '/about' },
  { label: 'Testimonials', path: '/testimonials' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-colors duration-200 ${
        scrolled ? 'bg-brand-black border-b border-brand-charcoal-light' : 'bg-brand-black/80 backdrop-blur-sm'
      }`}
    >
      <nav className="w-full px-6 lg:px-12 h-16 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-3 min-w-0 cursor-pointer">
          <img
            src="https://static.readdy.ai/image/461a3833cd00dd501e90f2080ae5acc6/9d83f2442d7248e622851343f7c2c853.png"
            alt="Holston Land Management Logo"
            className="h-8 lg:h-10 w-auto max-w-[150px] sm:max-w-[200px] lg:max-w-none object-contain"
          />
        </Link>

        {/* Desktop Links */}
        <div className="hidden lg:flex items-center gap-6">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`font-body text-sm font-500 tracking-wider uppercase transition-colors cursor-pointer whitespace-nowrap ${
                location.pathname === link.path
                  ? 'text-brand-green-accent'
                  : 'text-gray-300 hover:text-white'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className="ml-4 px-5 py-2 bg-brand-green hover:bg-brand-green-mid font-heading font-700 text-sm tracking-widest uppercase text-white transition-colors cursor-pointer whitespace-nowrap rounded-sm"
          >
            Get a Quote
          </Link>
        </div>

        {/* Mobile Toggle */}
        <button
          className="lg:hidden text-white w-10 h-10 flex items-center justify-center cursor-pointer"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          <i className={`ri-${menuOpen ? 'close' : 'menu'}-line text-2xl`} />
        </button>
      </nav>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="lg:hidden bg-brand-charcoal border-t border-brand-charcoal-light px-6 py-4 flex flex-col gap-4">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`font-body text-sm font-500 tracking-wider uppercase cursor-pointer ${
                location.pathname === link.path ? 'text-brand-green-accent' : 'text-gray-300'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <Link
            to="/contact"
            className="mt-2 px-5 py-2 bg-brand-green font-heading font-700 text-sm tracking-widest uppercase text-white text-center cursor-pointer whitespace-nowrap rounded-sm"
          >
            Get a Quote
          </Link>
        </div>
      )}
    </header>
  );
}
